import {
  // ADD_DESK_FAILURE,
  // ADD_DESK_LOADING,
  // ADD_DESK_SUCCESS,
  DELETE_DESK_FAILURE,
  DELETE_DESK_LOADING,
  DELETE_DESK_SUCCESS,
  FETCH_DESK_FAILURE,
  FETCH_DESK_LOADING,
  FETCH_DESK_SUCCESS,
  FETCH_ROOMS_ERROR,
  FETCH_ROOMS_LOADING,
  FETCH_ROOMS_SUCCESS,
  UPDATE_DESK_FAILURE,
  UPDATE_DESK_LOADING,
  UPDATE_DESK_SUCCESS
} from '../Types/deskType';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const deskReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_DESK_LOADING:
    case FETCH_ROOMS_LOADING:
    case UPDATE_DESK_LOADING:
    case DELETE_DESK_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_DESK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    // case ADD_DESK_SUCCESS:
    //   return {
    //     ...state,
    //     data: [...state.data, action.payload],
    //     loading: false,
    //     error: null,
    //     success: 'Desk added successfully'
    //     // item: action.payload
    //   };

    case UPDATE_DESK_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'Desk updated successfully'
      };

    case DELETE_DESK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Desk removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_DESK_FAILURE:
    case FETCH_ROOMS_ERROR:
    case UPDATE_DESK_FAILURE:
    case DELETE_DESK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    case FETCH_ROOMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        rooms: action.payload
      };

    default:
      return { ...state };
  }
};

export default deskReducer;
